import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";

import Wrapper from "../components/Wrapper";
import Header from "../components/Header";
import Body from "../components/Body";
import Footer from "../components/Footer";
import TopBar from "../components/TopBar";
import SubmitButton from "../components/SubmitButton";
import TrueMoney from "../assets/images/logo-truemoney_3.png";
import PaymentSuccess from "../assets/images/success_sharing.png";
import TruePattern from "../assets/images/truepattern.png";
import moment from "moment";

import _ from "lodash";
import numeral from "numeral";

const fontDefault = {
  fontFamily: "thonburiregular",
  fontStyle: "normal"
};

const styles = {
  topBarImg: {
    height: "28px"
  },
  title: {
    ...fontDefault,
    color: "#0e162c",
    fontSize: "18px",
    textAlign: "center",
    marginBottom: "3px",
    fontWeight: "bold"
  },
  price: {
    ...fontDefault,
    fontSize: "36px",
    color: "#233987",
    textAlign: "center",
    marginTop: "0px"
  },
  container: {
    margin: "16px"
  },
  containerInside: {
    marginTop: "16px"
  },
  item: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between"
  },
  text: {
    ...fontDefault,
    color: "#0e162c",
    fontSize: "14px"
  },
  textNoWrap: {
    ...fontDefault,
    color: "#0e162c",
    fontSize: "14px",
    whiteSpace: "nowrap",
    marginLeft: "24px"
  },
  textSan: {
    ...fontDefault,
    fontFamily: "San Francisco Text",
    color: "#0e162c",
    fontSize: "14px",
    whiteSpace: "nowrap",
    marginLeft: "24px"
  },
  textFade: {
    ...fontDefault,
    color: "#878b96",
    fontSize: "14px"
  },
  textSanFade: {
    ...fontDefault,
    fontFamily: "San Francisco Text",
    color: "#878b96",
    fontSize: "14px"
  },
  textBold: {
    ...fontDefault,
    color: "#0e162c",
    fontWeight: "bold",
    fontSize: "16px"
  },
  textSanBold: {
    ...fontDefault,
    fontFamily: "San Francisco Text",
    color: "#0e162c",
    fontSize: "16px",
    fontWeight: "bold"
  },
  line: {
    borderTop: "1px solid #c3c5cb",
    borderBottom: "none",
    marginTop: "16px",
    marginBottom: "16px",
    opacity: "0.5"
  },
  headDesc: {
    ...fontDefault,
    fontSize: "12px",
    color: "#878b96",
    textAlign: "center",
    marginBottom: "0px",
    marginTop: "0px"
  },
  sharingImage: {
    width: "100%",
    maxHeight: "150px",
    objectFit: "contain"
  }
};

class VerifyOTP extends Component {
  goToNextPage = () => {
    const {
      history: { push },
      auth = {}
    } = this.props;
    const { version = "v1" } = auth;
    if (version !== "v1") {
      push("/packages");
    } else {
      push("/home-old");
    }
  };

  componentDidMount = () => {
    const { auth = {} } = this.props;
    const { selectedPackage = {}, buyFor = "self", userInput = {} } = auth;
    const mixpanel = _.get(window, "mixpanel", undefined);
    if (!!mixpanel) {
      mixpanel.track("Insurance Corona Success", {
        Insurer: "Dhipaya",
        "Insurance type": "Dhipaya Corona",
        "Insurance package": selectedPackage.name,
        Amount: selectedPackage.total_prem,
        Recipient: buyFor === "self" ? "Buy for self" : "Buy for others"
      });
    }
    Object.keys(userInput).forEach(savedKey => {
      localStorage.removeItem(buyFor + savedKey);
    });
    //const {
    //  currentProduct,
    //  selectPrice,
    //  carBrand,
    //  carModel,
    //  carYear,
    //  insuranceClass,
    //  userInput,
    //} = this.props
    //const mixpanel = _.get(window, 'mixpanel', undefined)
    //const currentPackage = _.get(userInput, 'currentPackage', {})
    //if (!!mixpanel) {
    //  const orderSuccessData = _.get(userInput, 'orderSuccessData', {})
    //  const transactionData = _.get(orderSuccessData, 'transaction', {})
    //  mixpanel.track('Insurance Car Success', {
    //    'Insurance type':
    //      currentProduct === 'V'
    //        ? 'Voluntary Motor Insurance'
    //        : 'Compulsory Motor Insurance',
    //    'Insurance class': insuranceClass,
    //    Amount: selectPrice,
    //    'Car make': carBrand,
    //    'Car model': _.get(carModel, 'label', ''),
    //    'Car registration year': carYear,
    //  })
    //  mixpanel.people.set({
    //    'Last bought car insurance date': new Date(
    //      _.get(transactionData, 'transaction_at', new Date().toString())
    //    ).toLocaleString('th-TH'),
    //  })
    //}
    //const dataLayer = _.get(window, 'dataLayer', undefined)
    //if (!!dataLayer) {
    //  const orderSuccessData = _.get(userInput, 'orderSuccessData', {})
    //  const transactionData = _.get(orderSuccessData, 'transaction', {})
    //  const orderSuccessDataPolicy = _.get(
    //    orderSuccessData,
    //    'policy_product',
    //    []
    //  )
    //  dataLayer.push({
    //    event: 'purchase', // Required
    //    currencyCode: 'THB',
    //    ecommerce: {
    //      purchase: {
    //        actionField: {
    //          id: _.get(transactionData, 'resp_transaction_id', ''),
    //          revenue: selectPrice,
    //          tax: '0.00',
    //          shipping: '0.00',
    //          coupon: '',
    //        },
    //        products: orderSuccessDataPolicy.map(x => {
    //          return {
    //            id: x.id,
    //            name:
    //              x.product_sub_type === 'vmi'
    //                ? parseInt(_.get(currentPackage, 'risk', 0)) === 5
    //                  ? 'ประกันรถยนต์ชั้น 2+'
    //                  : parseInt(_.get(currentPackage, 'risk', 0)) === 5
    //                  ? 'ประกันรถยนต์ชั้น 1'
    //                  : 'ประกันรถยนต์ชั้น 3'
    //                : 'พ.ร.บ.',
    //            category:
    //              x.product_sub_type === 'vmi'
    //                ? 'Voluntary Motor Insurance'
    //                : 'Compulsory Motor Insurance',
    //            brand: 'Bangkok Insurance',
    //            variant:
    //              x.product_sub_type === 'vmi'
    //                ? parseInt(_.get(currentPackage, 'risk', 0)) === 5
    //                  ? 'ประกันรถยนต์ชั้น 2+'
    //                  : parseInt(_.get(currentPackage, 'risk', 0)) === 5
    //                  ? 'ประกันรถยนต์ชั้น 1'
    //                  : 'ประกันรถยนต์ชั้น 3'
    //                : 'พ.ร.บ.',
    //            price: x.package_price, // required
    //            quantity: 1, // required
    //          }
    //        }),
    //      },
    //    },
    //  })
    //}
  };

  render() {
    const { classes, auth } = this.props;
    const { successIssue = {}, selectedPackage = {}, userInput = {} } = auth;
    const { effDate, email } = userInput;
    const { resp_transaction_id, total_price } = successIssue;
    const { display_name_th, coverage = {} } = selectedPackage;
    const { illness = 0, medical_treatment = 0 } = coverage;
    return (
      <Wrapper>
        <Body style={{ backgroundImage: "url(" + TruePattern + ")" }}>
          <div className={classes.container}>
            <div style={{ marginLeft: "30px", marginRight: "30px" }}>
              <Grid container>
                <Grid justify="center" container style={{ marginTop: "10px" }}>
                  <Icon
                    className={classes.icon}
                    fontSize="large"
                    style={{ color: "#64cbac", fontSize: "72px" }}
                  >
                    check_circle
                  </Icon>
                </Grid>
              </Grid>
              <p className={classes.title}>ทำรายการสำเร็จ </p>
              <p className={classes.headDesc} style={{ marginTop: "3px" }}>
                เลขที่อ้างอิง: {resp_transaction_id}
              </p>
              <p className={classes.headDesc}>
                {new Date(
                  _.get(successIssue, "transaction_at", new Date().toString())
                ).toLocaleString("th-TH")}
              </p>
            </div>
            <div className={classes.containerInside}>
              <div className={classes.item}>
                <span className={classes.text}>ชำระสำหรับ</span>
                <span className={classes.text}>ทิพยประกันภัย</span>
              </div>
              <div className={classes.item}>
                <span className={classes.text}>ช่องทางชำระเงิน</span>
                <span className={classes.text}>ทรูมันนี่ วอลเล็ท</span>
              </div>
              <hr className={classes.line} />
              <div className={classes.item}>
                <span className={classes.text}>
                  ประกัยภัยส่วนบุคคลคุ้มครองการติดเชื้อ ไวรัสโคโรนา
                </span>
                <span className={classes.textNoWrap}>
                  ฿ {numeral(total_price).format("0,0.00")}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.textFade}>{display_name_th}</span>
              </div>
              <div className={classes.item}>
                <span className={classes.textFade}>วันที่เริ่มคุ้มครอง</span>
                <span className={classes.textSan}>
                  {moment(effDate)
                    .toDate()
                    .toLocaleDateString("th-TH", {
                      day: "numeric",
                      month: "long",
                      year: "numeric"
                    })}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.textFade}>วันสิ้นสุดคุ้มครอง</span>
                <span className={classes.textSan}>
                  {moment(effDate)
                    .add(1, "years")
                    .subtract(1, "days")
                    .toDate()
                    .toLocaleDateString("th-TH", {
                      day: "numeric",
                      month: "long",
                      year: "numeric"
                    })}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.textFade}>
                  การเจ็บป่วยในภาวะโคม่า จากการติดเชื้อไวรัสโคโรนา
                </span>
                <span className={classes.textSan}>
                  {numeral(illness).format("0,0")}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.textFade}>การรักษาพยาบาลต่อปี</span>
                <span className={classes.textSan}>
                  {numeral(medical_treatment).format("0,0")} บาท
                </span>
              </div>
              <hr className={classes.line} />
              <div className={classes.item}>
                <span className={classes.textBold}>ยอดชำระทั้งหมด</span>
                <span className={classes.textSanBold}>
                  ฿ {numeral(total_price).format("0,0.00")} บาท
                </span>
              </div>
              <br />
              <div
                style={{
                  backgroundColor: "rgba(255,131,0,0.15)",
                  padding: "8px",
                  borderRadius: "6px"
                }}
              >
                <div className={classes.item}>
                  <span
                    className={classes.textFade}
                    style={{
                      fontWeight: "bold",
                      color: "rgb(14 22 44)",
                      fontSize: "18px"
                    }}
                  >
                    หมายเหตุ:{" "}
                  </span>
                </div>
                <div className={classes.item} style={{ marginTop: "8px" }}>
                  <span
                    className={classes.textFade}
                    style={{ fontSize: "14px", color: "rgb(14 22 44)" }}
                  >
                    บมจ. ทิพยประกันภัยพิจารณาการรับประกันภัยและจัดส่ง
                    กรมธรรม์ให้คุณทางอีเมล ภายใน 7
                    วันทำการหากได้รับการพิจารณารับประกันภัย
                    หากไม่ได้รับอีเมลติดต่อ โทร. 1736 ต่อ 2309,2941,2009,4279
                  </span>
                </div>
              </div>
            </div>
          </div>
          {false && (
            <img
              src={PaymentSuccess}
              alt="sharing"
              className={classes.sharingImage}
            />
          )}
        </Body>
        <Footer style={{ backgroundColor: "white" }}>
          <SubmitButton margin={true} onClick={this.goToNextPage}>
            กลับ
          </SubmitButton>
        </Footer>
        <Header>
          <TopBar
            close={() => {
              window.location.replace("ascendmoney://closewebview");
            }}
          >
            <img
              className={classes.topBarImg}
              alt="True Money"
              src={TrueMoney}
            />
          </TopBar>
        </Header>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: _.get(state, "auth", {}),
    userInput: _.get(state, "motor.userInput", {}),
    currentProduct: _.get(state, "motor.userInput.currentProduct", ""),
    selectPrice: _.get(state, "motor.userInput.selectPrice", 0),
    carBrand: _.get(state, "motor.userInput.carBrand", ""),
    carModel: _.get(state, "motor.userInput.carModel", ""),
    carYear: _.get(state, "motor.userInput.carYear", ""),
    insuranceClass: _.get(state, "motor.userInput.insuranceClass", "")
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(VerifyOTP));
